import { styled } from "@mui/material/styles";
import { Card } from "@mui/material";

const CustomAsideCard = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  height: `calc(100vh - 80px)`,
  overflowY: "auto",
  // backgroundColor: "pink",
}));

export default CustomAsideCard;
